import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=43b2ffd8&scoped=true"
import script from "./destination.vue?vue&type=script&lang=js"
export * from "./destination.vue?vue&type=script&lang=js"
import style0 from "./destination.vue?vue&type=style&index=0&id=43b2ffd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2ffd8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default})
